export default __webpack_public_path__ + "static/media/preview-special-media.dcba638d.jpg";